/*
  Card quantity stepper.

  The basket button on a product card adds one unit and then turns into a - n + control,
  so a customer can keep adding without opening the cart.

  Presses land instantly: the number on screen is the shopper's, updated on every click,
  and the cart is caught up in the background. Rapid presses coalesce into ONE request for
  the final quantity instead of one request per press, and the cart drawer is refreshed
  once the flurry settles rather than after every tap.
*/
(function () {
  var R = (window.KROWN && KROWN.settings && KROWN.settings.routes) || {};
  var ADD = R.cart_add_url || '/cart/add';
  var CHANGE = R.cart_change_url || '/cart/change';
  var SETTLE = 320;        // ms of quiet before the cart is told the final number

  var lines = {};          // variant id -> { key, quantity } as the CART last reported
  var shown = {};          // variant id -> what the shopper can see right now
  var timers = {};         // variant id -> settle timer
  var inflight = 0;

  function readCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        lines = {};
        (c.items || []).forEach(function (i) {
          lines[String(i.variant_id)] = { key: i.key, quantity: i.quantity };
        });
        return lines;
      })
      .catch(function () { return lines; });
  }

  function holders() { return document.querySelectorAll('.product-item__quick-buy'); }

  function variantOf(holder) {
    var input = holder.querySelector('input[name="id"]');
    return input ? String(input.value) : null;
  }

  function build(holder) {
    var box = document.createElement('div');
    box.className = 'card-qty';
    box.innerHTML =
      '<button type="button" class="card-qty__btn" data-step="-1" aria-label="Remove one">&minus;</button>' +
      '<span class="card-qty__n" aria-live="polite">1</span>' +
      '<button type="button" class="card-qty__btn" data-step="1" aria-label="Add one">+</button>';
    holder.appendChild(box);
    box.addEventListener('click', function (e) {
      var btn = e.target.closest('.card-qty__btn');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      step(holder, parseInt(btn.dataset.step, 10));
    });
    return box;
  }

  function qtyOf(vid) {
    if (shown[vid] != null) return shown[vid];
    return lines[vid] ? lines[vid].quantity : 0;
  }

  var painting = false;
  function paint(holder) {
    var vid = variantOf(holder);
    if (!vid) return;                                  // multi-variant card: links to the product
    var q = qtyOf(vid);
    var adder = holder.querySelector('quick-add-to-cart');
    var box = holder.querySelector('.card-qty');
    if (q > 0) {
      box = box || build(holder);
      var n = box.querySelector('.card-qty__n');
      if (n.textContent !== String(q)) n.textContent = q;
      box.style.display = '';
      if (adder) adder.style.display = 'none';
      holder.classList.add('product-item__quick-buy--counting');
    } else {
      if (box) box.style.display = 'none';
      if (adder) adder.style.display = '';
      holder.classList.remove('product-item__quick-buy--counting');
    }
  }

  function paintAll() {
    painting = true;
    Array.prototype.forEach.call(holders(), paint);
    setTimeout(function () { painting = false; }, 0);
  }

  function post(url, body) {
    return fetch(url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function settled() {                 // everything sent: catch the header and drawer up
    if (inflight) return;
    readCart().then(function () {
      paintAll();
      if (typeof window.refreshCart === 'function') window.refreshCart(false);
    });
  }

  function flush(vid) {
    var want = shown[vid];
    if (want == null) return;
    var line = lines[vid];
    inflight++;
    var done = function () {
      inflight--;
      delete shown[vid];
      settled();
    };
    var req = line
      ? post(CHANGE, { id: line.key, quantity: want })
      : post(ADD, { items: [{ id: vid, quantity: want }] });
    req.then(function () { return readCart(); })
       .then(done)
       .catch(function () { inflight--; delete shown[vid]; settled(); });
  }

  function bump(holder, vid, delta) {
    var q = Math.max(0, qtyOf(vid) + delta);
    shown[vid] = q;
    paint(holder);                        // the number moves under the finger, now
    clearTimeout(timers[vid]);
    timers[vid] = setTimeout(function () { flush(vid); }, SETTLE);
  }

  function step(holder, delta) {
    var vid = variantOf(holder);
    if (vid) bump(holder, vid, delta);
  }

  // Take the click before the theme's own handler so the drawer does not fly open
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.product-item__quick-buy .quick-add-to-cart--minimal button[type="submit"]');
    if (!btn) return;
    var holder = btn.closest('.product-item__quick-buy');
    if (!holder || !variantOf(holder)) return;         // leave anything we cannot resolve alone
    e.preventDefault();
    e.stopPropagation();
    bump(holder, variantOf(holder), 1);
  }, true);

  document.addEventListener('cart-updated', function () { readCart().then(paintAll); });
  document.addEventListener('krown:cart:update', function () { readCart().then(paintAll); });

  function start() { readCart().then(paintAll); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // collection filtering and carousels swap cards in and out; debounced, and muted
  // while we are the ones writing, so our own paint cannot re-trigger the observer
  var pending = null;
  var observer = new MutationObserver(function () {
    if (painting) return;
    clearTimeout(pending);
    pending = setTimeout(paintAll, 250);
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
